export default "__VITE_ASSET__av7b4ahl__"